import apiClient from "../api/apiClient";
import { endPoints } from "../config/endpoints";

export const userActivityService = {
  async getAllAsync(params) {
    const response = await apiClient.get(endPoints.userActivity.getAll, {
      params,
    });
    return response.data;
  },

  async getAllSearchAsync(params, signal) {
    const response = await apiClient.get(endPoints.userActivity.getAllSearch, {
      params,
      signal,
    });
    return response.data;
  },
};
